import { Component, OnInit, ViewChild } from '@angular/core';
import { UnitSystem } from '../../details/UnitSystem';
import { ProductService } from '../../service/ProductService';
import { Products } from '../../details/Products';
import { ASStandardOringSizesService } from '../../service/ASStandardOringSizesService';
import { OringRecommendationComponent } from '../oring-recommendation/oring-recommendation.component';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { GrooveRecommendationComponent } from '../groove-recommendation/groove-recommendation.component';
import { DesignValidationComponent } from '../design-validation/design-validation.component';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { HeaderComponent } from '../header/header.component';
import { FormService } from '../../service/FormService';
import { TooltipsService } from '../../service/tooltips.service';
import { DataToSaveService } from '../../service/data-to-save.service';
import { ImportService } from '../../service/import.service';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import { TrackingService } from '../../service/tracking.service';
import { Router, NavigationStart } from '@angular/router';
import { NotificationsService } from '../../service/notifications.service';
import {AuthGuard} from "../../service/auth-guard.service"; // don't remove this line, it's used in the child compnents;

enum UnitSystemTypes {
  METRIC,
  ENGLISH
}

enum RecommendationType {
  activateOring,
  activateGroove,
  activateDesign
}

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
  providers: [ASStandardOringSizesService, ProductService, FormService, TooltipsService, NotificationsService],
  animations: [trigger('slideHeight', [state('closed', style({display: 'none', height: 0})), state('open',
              style({display: 'block', height: '*'})), transition('* => *', [style({display: 'block'}),
              animate('0.1s ease')])])
  ]
})
export class HomeComponent implements OnInit {
  products: Array<Products>;
  measurementUnit: string;
  aSStandardOringSizes;
  aSStandardOringJisSizes;
  ASStandardOring;
  options = {
    placeholder: 'Product',
    minimumResultsForSearch: Infinity
  };
  CTE: any = ' ';
  userForm: FormGroup;
  selectedProduct: string;
  calculationData = {
    grooveData: ' ',
    grooveType: ' ',
    oringData: ' ',
    units: ' ',
    CTE: ' '
  };
  recommendations = {
    activateOring: false,
    activateGroove: false,
    activateDesign: false
  };
  summaryData: object;
  temperatureUnit: string;
  estimateGrooveSize = false;
  estimateGrooveSizeUnit = false;
  state = 'open';
  static isOringFormValid = false;
  static isGrooveFormValid = false;
  isProductSelected = false;
  customOringData;
  calculatedData;
  oringEstimated = false;
  grooveEstimated = false;
  openPdfClicked = false;
  productName: string;
  product: any;
  tooltips = [];
  measurementType = 0;
  recommendationType: number;
  numberMask = createNumberMask({
    integerLimit: 4,
    includeThousandsSeparator: false,
    allowDecimal: true,
    decimalLimit: 2,
    prefix: ''
  });
  mask = this.numberMask;
  static productsData;


  @ViewChild('unitChange') oringComp: OringRecommendationComponent;
  @ViewChild('exportComp') grooveComp: GrooveRecommendationComponent;
  @ViewChild('passComp') designComp: DesignValidationComponent;
  @ViewChild('headerComp') headerComp: HeaderComponent;
  @ViewChild('selectElement') select2;


  constructor(private productService: ProductService,
              private aSStandardOringSizesService: ASStandardOringSizesService,
              private builder: FormBuilder, private formService: FormService, private trackingService: TrackingService,
              private dataToSaveService: DataToSaveService, private importService: ImportService,
              private tooltipsService: TooltipsService, private router: Router) {

    this.userForm = builder.group({
      'recommendationType': new FormControl()
    });
  }

  ngOnInit() {
    this.getData();
    this.measurementUnit = UnitSystem.MetricMeasurementUnit;
    this.temperatureUnit = UnitSystem.CELSIUS;
    this.getTooltips();
    this.router.events
      .filter(event => event instanceof NavigationStart)
      .subscribe(() => {
        if (this.router.url === '/home') {
          this.dataToSaveService.setMeasurement(this.measurementType);
          if (Number(this.recommendationType) >= 0) {
            this.dataToSaveService.setRecommendationType(this.recommendationType);
          }
          if (this.product) {
            this.dataToSaveService.setProduct(this.product);
          }
        }
      });
    this.getSavedData();
    this.importService.getImportEmitter().subscribe((importResults) => {
      this.getImportedData(importResults);
    });
  }

  getData(dontChangeProduct?: boolean) {
    if(!HomeComponent.productsData) {
      this.productService.getProducts().subscribe(res => {
        const products = res.results.map((item, index ) => {
          item.ID = ++index;
          item.text = item['product_material'];
          return item;
        });
        const storedEmail = AuthGuard.readCookie('email') || localStorage.getItem('email');
        if (storedEmail.indexOf('@lamresearch.com') > -1 || storedEmail.indexOf('@appliedsealsglobal.com') > -1) {
          this.products = products;
        } else {
          this.products = products.filter(item => {
            return item['product_material'].indexOf('LM') === -1;
          });
        }
        if (dontChangeProduct) return;
        this.products.unshift(Object.assign({}, this.products[0]));
        this.products[0]['id'] = '';
        this.products[0]['text'] = '';
        HomeComponent.productsData = this.products;
      });
    }else {
      this.products = HomeComponent.productsData;
    }
    this.aSStandardOringSizesService.getASStandardOringSizes().subscribe(res => {
      this.aSStandardOringSizes = res;
    });
    this.aSStandardOringSizesService.getASStandardOringSizesJis().subscribe(res => {
      this.aSStandardOringJisSizes = res;
    });
  }

  selectUnitSystem(unitSystem: number) {
    this.estimateGrooveSizeUnit = true;
    this.temperatureUnit = UnitSystem.CELSIUS;
    if (UnitSystemTypes.ENGLISH === unitSystem) {
      this.measurementUnit = UnitSystem.EnglishMeasurementUnit;
    }else {
      this.measurementUnit = UnitSystem.MetricMeasurementUnit;
    }
    this.grooveComp.measurementUnit = this.measurementUnit;
    UnitSystem.convertDataToEnglish(this.oringComp.groveRecommendation, unitSystem);
    UnitSystem.convertDataToEnglish(this.grooveComp.oringDefaults, unitSystem);
    this.oringComp.updateLabels();
    this.measurementType = unitSystem;
    this.grooveComp.updateLabels();

    this.grooveComp.getOringLimitations(this.measurementUnit, true);
    this.grooveComp.checkForm(this.grooveComp.form);
    this.changeMask(unitSystem);
    this.formService.setUntouched(this.oringComp.form);
  }

  setGroveRecommendationData(recommendationData) {
    let ASStandardOring;
    if(OringRecommendationComponent.GroveRecommendationType === 'as') {
      ASStandardOring = this.aSStandardOringSizes.find(item => {
        return item['English(inch)'] == recommendationData.groveRecommendationData['AS'];
      });
    }else {
      ASStandardOring = this.aSStandardOringJisSizes.find(item => {
        return item['English(inch)'] == recommendationData.groveRecommendationData['AS'];
      });
    }
    this.ASStandardOring = ASStandardOring;
    this.grooveComp.initASStandardOringSizes();
    this.grooveComp.ASStandardOring = this.ASStandardOring;
    this.grooveComp.setOringSizeInputValues();
    this.grooveComp.getASbyIDAndCS();
    this.calculationData = {
      grooveData: recommendationData.groveRecommendation,
      grooveType: recommendationData.grooveType,
      oringData: this.ASStandardOring,
      units: this.measurementUnit,
      CTE: this.CTE
    };
    this.headerComp.data = this.calculationData;
    return this.calculationData;
  }

  selectRecommendationType(index: number) {
    this.estimateGrooveSize = false;
    Object.keys(this.recommendations).map(key => {
      this.recommendations[key] = false;
    });
    if ([RecommendationType[index]][0] === 'activateDesign') {
      Object.keys(this.recommendations).map(key => {
        this.recommendations[key] = true;
      });
    }
    this.recommendations[RecommendationType[index]] = true;
    this.oringComp.grooveItemData = null;
    this.oringComp.getGrooveLimitations(this.measurementUnit);
    this.oringComp.clearOringData();
    this.grooveComp.clearOringData();
    this.designComp.clearDesignData();
    this.recommendationType = index;
    this.dataToSaveService.clearedData = true;
    this.grooveComp.groveRecommendationType = 'as';
  }

  selectProduct(product) {
    // if (this.products[product.value]) {
    this.product = this.products.find((item: any) => item['id'] == product.value);
    this.selectedProduct = this.product['text'].split(' ')[1];
    if(!this.selectedProduct) {
      this.selectedProduct = this.product['text'];
    }
    this.CTE = this.product['cte'];
    this.productName = this.product['text'];
    // }
    this.isProductSelected = product.value > 0;
  }

  openPDF() {
    if (this.product.id) {
      window.open(this.product['data_sheet'], '_blank');
      this.trackingService.dataSheetOpened();
      return;
    }
    this.openPdfClicked = true;
  }

  emitEvent(e: string) {
    const dataToPass = {
      product: this.selectedProduct,
      grooveData: this.oringComp.groveRecommendation,
      grooveType: this.oringComp.grooveType,
      oringData: this.grooveComp.selectedASStandardOringSize || this.customOringData,
      units: this.measurementUnit,
      CTE: this.CTE
    };
    this.summaryData = dataToPass;
  }

  toggleState() {
    this.state = this.state === 'closed' ? 'open' : 'closed';
  }

  isDataFulFilled() {
    if (HomeComponent.isGrooveFormValid && HomeComponent.isOringFormValid) {
      return true;
    }
    return false;
  }

  getTooltip(tooltipName: string) {
    if (!this.tooltips.length) return;
    if (window.innerWidth <= 790) return null;
    const tooltip = this.tooltips.find((item) => {
      return item['key'] == tooltipName;
    });
    if (tooltip) {
      return tooltip.message;
    }
  }

  getTooltips() {
    if (this.tooltips.length) return;
    this.tooltipsService.getTooltips().then((res) => {
      this.tooltips = res.results;
    });
  }

  getSavedData(): void {
    const paths = this.dataToSaveService.getPaths();
    if (paths.length > 0 && paths[paths.length - 1] === 'saved-files') {
      this.recommendationType = this.dataToSaveService.getRecommendationType();
      this.measurementType = this.dataToSaveService.getMeasurement();
      this.selectUnitSystem(this.measurementType);
      if (this.dataToSaveService.getProduct()) {
        const productId = this.dataToSaveService.getProduct().id;
        this.product = this.dataToSaveService.getProduct();
        this.selectedProduct = this.product['text'].split(' ')[1];
        setTimeout(() => {
          this.select2.element.val(productId);
          this.select2.element.trigger('change');
        }, 500); // change this to observable
      }
    }
  }

  getImportedData(importedData: string[]) {
    if (importedData.length > 7) {
      let productNumber = importedData[7][0].trim().split(' ')[1];
      if(!productNumber) {
        productNumber = importedData[7][0].split(' ')[1];
      }
      this.selectedProduct = productNumber;
      this.measurementType = UnitSystemTypes[importedData[9][0].trim().toUpperCase()];
      this.selectUnitSystem(this.measurementType);
      const product: any = this.products.find((item: any) => {
        return item.text.indexOf(productNumber) > -1;
      });
      this.product = product;
      this.select2.element.val(product.id);
      this.select2.element.trigger('change');
    } else {
      this.measurementType = UnitSystemTypes[importedData[5][0].toUpperCase()];
      this.selectUnitSystem(this.measurementType);
    }
    HomeComponent.isGrooveFormValid = true;
    HomeComponent.isOringFormValid = true;
  }

  changeMask(unit: number) {
    if (unit === 0) {
      this.mask = createNumberMask({
        integerLimit: 4,
        includeThousandsSeparator: false,
        allowDecimal: true,
        decimalLimit: 2,
        prefix: ''
      });
    } else {
      this.mask = createNumberMask({
        integerLimit: 3,
        includeThousandsSeparator: false,
        allowDecimal: true,
        decimalLimit: 3,
        prefix: ''
      });
    }
  }
}



// WEBPACK FOOTER //
// /var/www/asna/front-end/public_html/src/app/components/home/home.component.ts